import { createItemCodeRedirect } from '@akyga/shared-ui/ItemCodeRedirect';
import httpClient from 'API/httpClient';

export default createItemCodeRedirect(httpClient);
